import React, { Component } from 'react';
import {fetchConstructionList} from 'actions/ConstructionActions';
import {CreateShiftRecordInPast} from 'actions/UserActions';
import { createPositionOptions, createWorkCategoryOptions} from './createPositionptions';

export default class EditShiftModalWithoutRecord extends Component {
  constructor(props) {
    super(props);

    let {siteList, user} = this.props;
    const maxYear = Math.max(
      ...siteList.filter(s => s.get('status') === 0)
          .map(s => s.get('year'))
      )

    this.state = {
      creating: false,
      years: siteList.filter(s => s.get('status') === 0 && s.get('year') > 0).map(s => s.get('year')).reduce((s, y) => {
        if (!s.includes(y)) s.push(y)
        return s;
      }, []).sort().reverse(),
      selectedYear: maxYear,
      selectedCid: siteList.getIn([
                    siteList.findIndex((site) => site.get('status') ===0 && (site.get('year') === maxYear || site.get('year') === 0)),
                    'cid']),
      selectedPid: user.get('role')
    }
  }

  componentDidMount() {
    this.props.dispatch(fetchConstructionList());
  }

  activeCreating = () => {
    this.setState({
      creating: true
    })
  }

  dismissCreating = () => {
    this.setState({
      creating: false
    })
  }

  handleSelectCid = (e) => {
    this.setState({
      selectedCid: e.target.value
    })
  }

  handleSelectYear = (e) => {
    this.setState({
      selectedYear: +e.target.value
    })
  }

  handleSelectedPid = (e) => {
    this.setState({
      selectedPid: e.target.value
    })
  }

  handleCreation = () => {
    let data = {
      cid: this.state.selectedCid,
      pid: this.state.selectedPid,
      startAt: this.props.date.format("YYYY-MM-DD"),
      lastFor: 1,
      shiftList: [this.props.sid]
    }

    this.props.dispatch(CreateShiftRecordInPast(data));
  }

  render() {
    let {creating, years, selectedYear, selectedCid, selectedPid} = this.state;
    let {siteList, positionList} = this.props;

    return (
      <div className="no-record">
        {creating?
          <div>
            <div className="form-inline">
              <select value={selectedYear} onChange={this.handleSelectYear} className="form-control">
                {years.map(year => {
                  return <option key={year} value={year}>工程年份-{year}</option>
                })}
              </select>
              {" "}
              <select value={selectedCid} onChange={this.handleSelectCid} className="form-control">
                {siteList
                  .filter((site) => {
                    return site.get('status') === 0 && (site.get('year') === 0 || site.get('year') === selectedYear)
                  })
                  .map((site) => (
                  <option key={site.get('name')} value={site.get('cid')}>{site.get('name')}</option>
                ))}
              </select>
              {" "}
              <select value={selectedPid} onChange={this.handleSelectedPid} className="form-control">
                {createWorkCategoryOptions(positionList)}
                {createPositionOptions(positionList)}
              </select>
              {" "}
              <button className="btn btn-primary btn-sm" onClick={this.handleCreation}>
                新增
              </button>
              {" "}
              <button className="btn btn-default btn-sm" onClick={this.dismissCreating}>
                取消
              </button>
            </div>
          </div>
        :
          <div>
            <div className="announce">沒有任何記錄</div>
            <button className="btn btn-primary btn-sm" onClick={this.activeCreating}>
              新增編更
            </button>
          </div>
      }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Schedule/EditShiftModalWithoutRecord.js